import useProtectedMutation from './use-protected-mutation';

import RebatesClient from '../RebatesClient';

/**
 * Soft-deletes a statement via DELETE /api/report/statements/:id.
 *
 * @param {Object} [options]
 * @param {Function} [options.onSuccess] called after a successful delete
 *   (e.g. to refetch the list).
 */
export default function useDeleteStatement({ onSuccess } = {}) {
  return useProtectedMutation({
    mutationKey: ['delete_statement'],
    mutationFn: async (statementId) => {
      const result = await RebatesClient.deleteStatement(statementId);

      if (!result.response.ok) {
        throw new Error(result.body?.status || 'Error deleting statement');
      }

      return statementId;
    },
    onSuccess
  });
}
